{
  "fallbackName": "Volunteer",
  "details": "Details",
  "retry": "Retry",
  "assignedHeading": "Assigned Training",
  "assignTraining": "Assign Training",
  "emptyTitle": "No Assigned Training",
  "emptyMessage": "{{person}} hasn't been assigned any Training Modules yet.",
  "anotherTeam": "Another team",
  "unavailableModule": "Unavailable Module",
  "moduleUnavailable": "This Training Module is no longer available.",
  "completed": "Completed",
  "lessonsComplete_one": "{{count}} Lesson complete",
  "lessonsComplete_other": "{{count}} Lessons complete",
  "notStarted": "Not started",
  "due": "Due {{date}}",
  "overdue": "Overdue {{date}}",
  "via": "via {{team}}"
}
